import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React, { useContext } from 'react';

import SSRegulatoryTermsDefault from './SSRegulatoryTermsDefault';
import SSRegulatoryTermsMEDDRA from './SSRegulatoryTermsMEDDRA';
import { useFormSelector } from '../../../custom-hooks';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { FCM_BORDER_STYLES, FCM_HIDDEN_CONTROL_STYLES } from '../../constants/runtime.constants';
import { SubGridContext } from '../../context';
import { getIsFormChangesMode } from '../../selectors/common.selectors';
import { getEvaluatedExpression } from '../../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    padding: '8px 0',
  },
  changesModeWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: ({ isControlChangedFCM }) => `36px ${isControlChangedFCM ? 26 : 6}px 0px 6px`,
  },
  coloredBorder: {
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  changesIcon: {
    position: 'absolute',
    top: 4,
    right: 8,
  },
  smallPaddingTop: {
    paddingTop: '6px !important',
  },
});

const SSRegulatoryTermsZoom = (props) => {
  const {
    regulatoryTerms,
    id,
    index,
    inTable,
    inFieldGroup,
    isHiddenLabel,
    textBoxPropsJson = '{}',
    isEditor,
    isControlHiddenFCM,
    isControlAddedFCM,
    isControlChangedFCM,
  } = props;

  const classes = useStyles({ isControlAddedFCM, isControlChangedFCM });
  const inSubGrid = useContext(SubGridContext);
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);
  const termHierarchy = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.TERM_HIERARCHY,
  });

  const isInTable = inTable || (inFieldGroup && isHiddenLabel);
  const controlProps = { ...props, termHierarchy, isInTable };
  const { isTextBoxViewOnly, isTextBoxHidden } = JSON.parse(textBoxPropsJson);
  const isHidden = isControlHiddenFCM || isTextBoxViewOnly || isTextBoxHidden;

  if (isTextBoxViewOnly && !isEditor && !isFormChangesMode) {
    return null;
  }

  const component =
    regulatoryTerms === 'MEDDRA' ? (
      <SSRegulatoryTermsMEDDRA {...controlProps} />
    ) : (
      <SSRegulatoryTermsDefault {...controlProps} />
    );

  if (isEditor || !isFormChangesMode) {
    return component;
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.root}>
        <div
          className={classNames(classes.changesModeWrapper, classes.coloredBorder)}
          data-ss-id={id}
        >
          <span className={isHidden ? classes.hiddenControl : null} data-hidden-fcm={isHidden}>
            {component}
          </span>
          {isControlChangedFCM && (
            <div className={classes.changesIcon}>
              <ControlChangesIcon id={id} />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(classes.root, isHidden ? classes.hiddenControl : '')}
      data-hidden-fcm={isHidden}
    >
      <div
        className={classNames(
          classes.changesModeWrapper,
          inSubGrid || inTable || isTextBoxViewOnly ? classes.smallPaddingTop : ''
        )}
      >
        {component}
      </div>
    </div>
  );
};

export default SSRegulatoryTermsZoom;
